import { Injectable } from '@angular/core';
import { NavigationDropdownItem } from './navigation-dropdown-item';
import { NavigationElement } from './navigation-element';
import { NavigationFormArray } from './navigation-form-array';
import { FormGroup, FormArray, FormControl } from '@angular/forms';

@Injectable({
	providedIn: 'root'
})
export class NavigationElementFactory {
	/**
	 * Factory method that returns a `NavigationElement`
	 * @param formArrayKeysExclusions
	 * @param formArrayKeysToFlat
	 * @param nameCallback
	 * @param element
	 */
	get(element: NavigationDropdownItem | FormGroup,
		formArrayKeysExclusions: Array<string>,
		formArrayKeysToFlat: Array<string>,
		nameCallback: (...any) => any): NavigationElement {
		if (element instanceof FormGroup) {
			return {
				control: element,
				name: nameCallback(element),
				dropdownItems: this.getDropdownItems(
					this.getNavigationFormArrays(element, formArrayKeysExclusions),
					formArrayKeysToFlat,
					nameCallback
				),
				key: 'root',
				index: null
			};
		} else {
			return {
				control: element.control,
				name: element.name,
				dropdownItems: this.getDropdownItems(
					this.getNavigationFormArrays(element.control, formArrayKeysExclusions),
					formArrayKeysToFlat,
					nameCallback
				),
				key: element.key,
				index: element.index,
			};
		}
	}

	/**
	 * getNavigationFormArrays
	 * return an array of objects, each object
	 * @param control
	 */
	private getNavigationFormArrays(
		control: FormGroup | FormControl,
		formArrayKeysExclusions: Array<string>
	): Array<NavigationFormArray> {
		const controls = control instanceof FormGroup ? control.controls : {};
		return Object.keys(controls)
			.filter(key =>
				controls[key] instanceof FormArray &&
				formArrayKeysExclusions.indexOf(key) === -1
			)
			.reduce((acc, key) => {
				acc.push({
					parent: control,
					key: key,
					controls: controls[key]
				});
				return acc;
			}, []);
	}

	/**
	 * getDropdownItems
	 * get items to pass to the dropdown component, if item is in `formArrayKeysToFlat`
	 * it will flat the array
	 * @param navigationElement
	 */
	private getDropdownItems(
		formArrayControls: Array<NavigationFormArray>,
		formArrayKeysToFlat: Array<string>,
		nameCallback: (...any) => any
	): Array<NavigationDropdownItem> {
		let items = [];
		formArrayControls.forEach(formArrayControl => {
			if (formArrayKeysToFlat.indexOf(formArrayControl.key) > -1) {
				items = [
					...items,
					...formArrayControl.controls.controls.map((control, index) => ({
						control: control,
						name: nameCallback(control, formArrayControl.key, index),
						index: index,
						key: formArrayControl.key
					}))
				];
			} else {
				items.push({
					control: formArrayControl.controls.controls[0] || (new FormGroup({})),
					name: nameCallback(formArrayControl.parent, formArrayControl.key),
					index: null,
					key: formArrayControl.key
				});
			}
		});
		return items;
	}
}
